const setAppsMetadataItems = (payload) => ({ type: 'pieveSetAppsMetadataItems', payload });

export default setAppsMetadataItems;
